/*
 * Dashboard Messages
 *
 * This contains all the text for the Dashboard container.
 */

import { defineMessages } from "react-intl";

export const scope = "app.containers.Dashboard";

export default defineMessages({
  header: {
    id: `${scope}.header`,
    defaultMessage: "This is the Dashboard container!",
  },
  uglyButtonText: {
    id: `${scope}.uglyButtonText`,
    defaultMessage: "Plan appointment",
  },
  planAppointmentHeader: {
    id: `${scope}.planAppointmentHeader`,
    defaultMessage: "Plan an appointment",
  },
  orderProductHeader: {
    id: `${scope}.orderProductHeader`,
    defaultMessage: "Order",
  },
  orderProduct: {
    id: `${scope}.orderProduct`,
    defaultMessage: "Order Product",
  },
  dashboard_messages: {
    id: `${scope}.dashboard_messages`,
    defaultMessage: "Messages",
  },
  openMessage: {
    id: `${scope}.openMessage`,
    defaultMessage: "open messages",
  },
  selectPatientOrder: {
    id: `${scope}.selectPatientOrder`,
    defaultMessage: "Select a patient and place an order",
  },
});
